import React from 'react';
// Constants
import { CompanyPhoneNumber, ContactEmailAddress, LocationCity } from '../../utils/Constants';

function TopBarCta() {
  return (
    <section className='grid w-full h-fit bg-colour3 full_shadow_black_invert_thin'>
      <div className='grid grid-flow-col items-center lg:grid-cols-3 justify-evenly gap-4 py-1 px-2 lg:px-12 md:text-xs'>
        <div className='grid'>
          <a href={`tel:${CompanyPhoneNumber}`} className='text-colour2'>
            <span className='font-medium'>Call Now:</span> {CompanyPhoneNumber}
          </a>
        </div>

        <div className='hidden md:grid grid-flow-col justify-center'>
          <span className='font-medium'>Email:</span>
          <a
            href={`mailto:${ContactEmailAddress}`}
            className='text-colour2 ml-1'
          >
            {ContactEmailAddress}
          </a>
        </div>

        <div className='hidden md:grid justify-end'>
          <span>{LocationCity} - Devon/Cornwall</span>
        </div>
      </div>
    </section>
  );
}

export default TopBarCta;
